<div class="edit-header">
  <mat-divider></mat-divider>
  <span>{{fieldLabel}}</span>
  <mat-divider></mat-divider>
</div>

<button mat-stroked-button class="query-filter-icon" [matMenuTriggerFor]="iconMenu">
  <mat-icon>{{icon}}</mat-icon>
</button>

<mat-menu #iconMenu="matMenu" xPosition="before" class="icon-menu-picker">
  <button mat-menu-item *ngFor="let filterIcon of filterIcons" (click)="iconSelected(filterIcon.icon)"
          matTooltipPosition="right"
          [matTooltipDisabled]="false"
          [matTooltip]="filterIcon.tooltip" [disabled]="filterIcon.icon === icon">
    <mat-icon>{{filterIcon.icon}}</mat-icon>
  </button>
</mat-menu>

<mat-form-field [class.mat-form-field-invalid]="filterNameError|async" floatLabel="never" class="query-filter-name" appearance="outline">
  <mat-label>Display Name</mat-label>
  <input matInput autocomplete="off" [(ngModel)]="displayName" (ngModelChange)="filterNameUpdated($event)" placeholder="Cool Filter">
  <mat-hint class="mat-error query-filter-name-error" *ngIf="filterNameError|async as error">{{error}}</mat-hint>
</mat-form-field>
<button mat-stroked-button #button (click)="done(button)" [color]="buttonColor"
        [disabled]="doneDisabled">{{buttonText}}</button>
